module.exports = __webpack_public_path__ + "img/slide-19.3a2eddd1.jpg";